import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const Container = styled.div`
  max-width: 500px;
  width: 100%;
  min-width: 300px;
  height:650px;
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  border: 10px solid #ebebeb;
  overflow: hidden;
  margin-top: -var('--regi-nav-height');
  z-index: 2;

  ${mq(Devices.mobile)} {
    margin: 0 10px;
  }
`;

export const PreviewTop = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  background: #ebebeb;

  span {
    font-size: 20px;
    font-weight: 700;
  }
`;

export const CloseButton = styled.button`
  margin-left: auto;
  background: #2a848e;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  svg {
    height: 48%;
    path {
      fill: #fff;
    }
  }

  :hover {
    background: #2a848ecc;
  }
`;

export const PreviewRow = styled.div<{ center?: boolean }>`
  min-height: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: ${(props) => (props.center ? 'center' : 'unset')};
  align-items: ${(props) => (props.center ? 'center' : 'unset')};
  padding: 10px 20px;
`;

export const PreviewTitle = styled.span`
  font-size: 18px;
  color: #000;
  margin-top: 10px;
`;

export const PreviewItem = styled.div`
  background: #f5f5f4;
  width: 100%;
  border-radius: 6px;
  padding: 14px;
`;

export const PreviewItemTop = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 20% 51% 4% 25%;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f5f5;
  aspect-ratio: 1 / 1.3;
  cursor: pointer;
`;

export const PreviewStats = styled.div`
  display: flex;

  span {
    display: flex;
    align-items: center;
    font-size: 16px;
  }

  span:nth-of-type(1) {
    color: #feb445;
    font-weight: 600;
  }

  span:nth-of-type(2) {
    margin-left: auto;
    color: rgba(${(props) => props.theme.colors.blue_rgb}, 1);
  }

  svg {
    width: 14px;
    margin-left: 6px;
  }
`;

export const PreviewStatsLimit = styled.div`
  display: flex;

  span {
    display: flex;
    align-items: center;
    align-content: center;
    font-size: 16px;
    color: #feb445;
    font-weight: 600;
    color: rgba(${(props) => props.theme.colors.blue_rgb}, 1);
  }
`;

export const PreviewIcon = styled.div<{ progress?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  div{
    height:100%;
    max-height: 180px;
    aspect-ratio: 1 / 1;
  }
  svg {
    width:100%;
  }
`;

export const PreviewDescription = styled.div`
  font-size: 18px;
  color: #171717;
  max-width: 550px;
`;
